import cssUtil from 'gw-portals-util-js/CssUtil';
import template from 'text!./RepairFacilitiesListItem.html';
import styles from './RepairFacilitiesListItem-hashed.scss';
import controller from './RepairFacilitiesListItemCtrl';

export default {
    template: cssUtil.hashTemplate(template, styles),
    controller: controller,
    bindings: {
        model: '<',
        selected: '<',
        onScrollIntoView: '&'
    }
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/fnol/pa/components/RepairFacilitiesListItem/index.js
// module id = 1560
// module chunks = 0